import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/home';
import Homepage from '../pages/home/Homepage';
import DocsPage from '../pages/Docs/DocsPage';
import Signup from '../pages/signup';
import EmailOtp from '../pages/login/EmailOtp';
import Otp from '../pages/login/Otp';
import Protect from '../pages/home/Protect';
import { useSelector } from 'react-redux';
import Domain from '../pages/Domain/Domain';
import Follower from '../pages/Domain/Follower';
import Following from '../pages/Domain/Following';
import Login from '../pages/login/Login';
import DemoLogin from '../pages/login/DemoLogin';
import PrivacyPolicy from '../pages/legal/PrivacyPolicy';
import TermsOfService from '../pages/legal/TermsOfService';
import AccessibilityStatement from '../pages/legal/AccessibilityStatement';

function AuthRoutes() {
    const isProtected = useSelector((state) => state.auth.protect);

    return (
        <Routes>
            {/* Legal pages - accessible to everyone */}
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/accessibility-statement" element={<AccessibilityStatement />} />

            {!isProtected ? (
                <>
                    <Route path="/" element={<Protect />} />
                    <Route path="/demo" element={<DemoLogin />} />
                    <Route path="/docs" element={<DocsPage />} />
                    <Route path="/:domain" element={<Domain />} />
                    <Route path="/staging/:domain" element={<Domain />} />
                    <Route path="/staging/:domain/:focuspage" element={<Domain />} />
                    <Route path="/follower/:domain" element={<Follower />} />
                    <Route path="/following/:domain" element={<Following />} />
                </>
            ) : (
                <>
                    {/* Changed root to Login page instead of Homepage */}
                    <Route path="/" element={<Home />} />
                    {/* Demo login route - accessible from external sites */}
                    <Route path="/demo" element={<DemoLogin />} />
                    {/* Homepage temporarily hidden - keeping route accessible for development */}
                    <Route path="/homepage" element={<Homepage />} />
                    <Route path="/docs" element={<DocsPage />} />
                    <Route path="/login" element={<Home />} />
                    <Route path="/login-otp-email" element={<EmailOtp />} />
                    <Route path="/login-otp" element={<Otp />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/:domain" element={<Domain />} />
                    <Route path="/staging/:domain" element={<Domain />} />
                    <Route path="/staging/:domain/:focuspage" element={<Domain />} />
                    <Route path="/follower/:domain" element={<Follower />} />
                    <Route path="/following/:domain" element={<Following />} />
                </>
            )}
        </Routes>
    );
}

export default AuthRoutes;
